import { HeaderHeightContext } from './HeaderHeightContext';
import { useContext } from 'react';
/**
 * React hook for obtaining the header height. Any value that whose change should trigger a
 * render should be passed as "input"
 */
export const useHeaderHeight = () => useContext(HeaderHeightContext)[0];
//# sourceMappingURL=useHeaderHeight.js.map